import React from "react";
import LoadingIcon from '../images/loading.gif'

export default function Loader(props){
    return(
        <div>
            <img src={LoadingIcon} alt="loading" className={`search-loading ${ props.loading ? 'show' : 'hide' }`}/>
        </div>
    )
}